export class RouteUtil {
  public static readonly DASHBOARD_MODULE = '';
  public static readonly DASHBOARD_COMPONENT = '';
  public static readonly home_COMPONENT = '';
  public static readonly ABOUT_US = 'aboutus';
  public static readonly ROLES = 'roles';
  public static readonly TRUST = 'trust';
  public static readonly CONTACT_US = 'contactus';
}
